import type { GetMultipleDocumentsUploadFieldValueProps } from "./documents-upload-field.type";
import type { Document, DocumentsUploadPayload } from "@/entities/document";
import type { UploadExistingFile } from "@/modules/upload-file";

import { convertDocumentsToExistingPayload } from "@/entities/document";
import {
  convertDocumentToUploadExistingFile,
  convertUploadFormItemValueToDocumentUploadPayload,
} from "@/modules/document/document-upload-field";

export const convertDocumentsToUploadExistingFiles = (
  documents?: Document[]
): UploadExistingFile[] => {
  return (documents ?? [])
    .map(convertDocumentToUploadExistingFile)
    .filter((file) => !!file);
};

export const getMultipleDocumentsUploadFieldValue = ({
  formValue,
  defaultDocuments,
}: GetMultipleDocumentsUploadFieldValueProps): DocumentsUploadPayload => {
  const defaultValue = convertDocumentsToExistingPayload(defaultDocuments);

  // Field has not been touched yet
  if (!formValue) return defaultValue;

  // Field has been touched and is empty, return empty array to reset DB
  if (formValue.length === 0) return [];

  // Let's loop through all files and return new uploaded files (originFileObj)
  // or existing file (name/path object)
  return formValue
    .map(convertUploadFormItemValueToDocumentUploadPayload)
    .filter((file) => !!file);
};
